var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 888.56,
    height: 741.645,
    viewBox: "0 0 888.56 741.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.786,
    y1: 0.026,
    x2: 0.007,
    y2: 1.108,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcd5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#a2bdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#819fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    stopColor: "#6a89ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#5b7cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.786,
    y1: 9.562,
    x2: -1.495,
    y2: 10.545,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#c4daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "#d3e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9ffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 4.749,
    y1: 0.5,
    x2: 5.749,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 22.836,
    y1: 0.5,
    x2: 23.836,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5778ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#5b7cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#6a89ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#819fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#a2bdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcd5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 3.844,
    y1: 0.5,
    x2: 4.844,
    y2: 0.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 4.179,
    y1: 0.5,
    x2: 5.179,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 16.053,
    y1: 0.5,
    x2: 17.053,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M293.883,84.06l369.98,213.608L617.982,568.149,248.251,354.685Z",
    transform: "translate(-248.251 -84.06)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 3.414,
    y1: 0.5,
    x2: 4.414,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 11.231,
    y1: 0.5,
    x2: 12.231,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.791,
    cy: 0.5,
    r: 1.147,
    gradientTransform: "matrix(-0.578, 0, 0, 1, 13.754, 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3aa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182484"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.791,
    cy: 0.5,
    r: 0.632,
    gradientTransform: "matrix(-1.259, 0, 0, 1, 28.84, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 8.71,
    y1: 1.141,
    x2: 9.196,
    y2: -0.008,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5778ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5b7cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    stopColor: "#6a89ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#819fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#a2bdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#bcd5ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 10.026,
    y1: 1.153,
    x2: 9.677,
    y2: 0.274,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 5.669,
    y1: 0.975,
    x2: 5.156,
    y2: 0.009,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#c2d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.134,
    stopColor: "#cce2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#dbf1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#e9ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    stopColor: "#d8eeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#cae0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#c2d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#c0d6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#d0e6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#e9ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0d6ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(-19.218 -206.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(66.731 435.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M161.388,316.783,72.816,265.647c-1.513-.876-1.325-2.4.426-3.414l87.719-50.645a6.561,6.561,0,0,1,5.909-.244l88.572,51.137c1.515.874,1.325,2.4-.424,3.412L167.3,316.537A6.572,6.572,0,0,1,161.388,316.783Z",
    transform: "translate(-28.094 -157.442)",
    fill: "#242993",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M186.272,356.15a8.637,8.637,0,0,1-4.247-.995L52.461,280.351a3.507,3.507,0,0,1-1.979-3.006,4.491,4.491,0,0,1,2.6-3.66L181.4,199.6c2.869-1.653,7.093-1.811,9.613-.357l129.565,74.8a3.506,3.506,0,0,1,1.979,3.006,4.489,4.489,0,0,1-2.6,3.66L191.636,354.8A10.993,10.993,0,0,1,186.272,356.15Zm-3.281-2.67c1.913,1.105,5.43.943,7.681-.357l128.32-74.085c1.023-.591,1.634-1.335,1.634-1.987a1.719,1.719,0,0,0-1.015-1.333l-129.565-74.8c-1.913-1.105-5.43-.943-7.681.359L54.048,275.36c-1.023.591-1.634,1.333-1.634,1.985a1.717,1.717,0,0,0,1.013,1.333Z",
    transform: "translate(-50.482 -170.578)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(43.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M256.452,246.4V229.311l-27.831.018-61.75-35.651a6.568,6.568,0,0,0-5.909.244L99.487,229.415l-27.692.018,0,17.128h.016a1.759,1.759,0,0,0,1,1.419l88.57,51.137a6.566,6.566,0,0,0,5.911-.246l87.719-50.645A2.491,2.491,0,0,0,256.452,246.4Z",
    transform: "translate(-71.794 -176)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M161.388,290.784,72.816,239.648c-1.513-.876-1.325-2.4.426-3.414l87.719-50.645a6.561,6.561,0,0,1,5.909-.244l88.572,51.137c1.515.873,1.325,2.4-.424,3.412L167.3,290.538A6.572,6.572,0,0,1,161.388,290.784Z",
    transform: "translate(-71.795 -184.753)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M156.327,281.693l-78.51-45.328c-1.343-.775-1.175-2.13.377-3.024l77.754-44.893a5.825,5.825,0,0,1,5.241-.217l78.51,45.328c1.343.775,1.173,2.13-.377,3.024l-77.756,44.893A5.821,5.821,0,0,1,156.327,281.693Z",
    transform: "translate(-66.421 -181.651)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M153.116,275.928,80.987,234.283c-1.234-.712-1.079-1.956.347-2.778l71.436-41.243a5.345,5.345,0,0,1,4.812-.2l72.131,41.645c1.232.712,1.079,1.956-.347,2.778L157.93,275.729A5.355,5.355,0,0,1,153.116,275.928Z",
    transform: "translate(-63.014 -179.684)",
    fill: "#4553c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(123.253 43.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M120.339,213.287l-8.435-4.87,4.606-2.659,8.435,4.87Z",
    transform: "translate(-109.213 -205.758)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M130.344,210.456l-8.435,4.87-4.606-2.659,8.435-4.87Z",
    transform: "translate(-103.541 -203.616)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M119.8,211.331,115.2,213.99l-4.606-2.659,4.606-2.659Z",
    transform: "translate(-110.592 -202.697)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M132.01,218.379l-4.606,2.659-13.281-7.668,4.606-2.659Z",
    transform: "translate(-106.882 -200.555)",
    fill: "#42ffff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M210.855,432.721a10.359,10.359,0,0,1-5.188-1.384l-176.83-102a3.051,3.051,0,0,1,0-5.286l116.53-67.276.966,1.673L29.8,325.728a1.12,1.12,0,0,0,0,1.94l176.832,102a8.479,8.479,0,0,0,8.454,0l35.674-20.6.966,1.673-35.676,20.6A10.37,10.37,0,0,1,210.855,432.721Z",
    transform: "translate(-8.092 326.471)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(189.794 206.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(268.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M244.491,363.4,292.517,78.466l-3.861-1.626,5.8-3.328-.01.035c1.126-.75,2.719-.7,4.472.308l383.829,221.6c3.152,1.819,5.536,6.488,4.983,9.75l-48.408,287.2a3.6,3.6,0,0,1-2.022,2.924h.006l-5.68,3.281-.974-5.3.324.1-381.5-220.261C246.322,371.33,243.937,366.663,244.491,363.4Z",
    transform: "translate(-238.389 -73.034)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M492.46,186.739l6.309-2.791a8.672,8.672,0,0,1,.812,4.749L451.173,475.9a3.6,3.6,0,0,1-2.022,2.924l.006,0-5.68,3.279-.974-5.3.324.1-19.305-11.146Z",
    transform: "translate(-50.237 43.478)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M246.539,374.84l383.827,221.6c2.965,1.712,5.5.724,6.022-2.344L684.8,306.9c.556-3.264-1.831-7.931-4.983-9.75L295.984,75.546c-2.963-1.71-5.5-.722-6.02,2.346l-48.41,287.2C241,368.353,243.387,373.02,246.539,374.84Z",
    transform: "translate(-241.474 -71.27)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(13.896 22.608)",
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M293.883,84.06l369.98,213.608L617.982,568.149,248.251,354.685Z",
    transform: "translate(-248.251 -84.06)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(0 302.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M532.858,639.552a19.444,19.444,0,0,1-9.5-2.4L114.9,401.235c-2.795-1.614-4.4-3.82-4.4-6.057,0-1.913,1.154-3.631,3.248-4.841L371.56,241.487c4.431-2.555,11.872-2.268,16.941.662L796.963,478.064c2.795,1.614,4.4,3.82,4.4,6.057,0,1.913-1.154,3.633-3.248,4.841L540.3,637.812A15.11,15.11,0,0,1,532.858,639.552ZM378.981,241.682a13.151,13.151,0,0,0-6.457,1.478L114.713,392.01c-1.495.861-2.282,1.956-2.282,3.17,0,1.526,1.249,3.123,3.428,4.382L524.32,635.474c4.452,2.571,11.187,2.873,15.012.664l257.813-148.85c1.493-.861,2.28-1.956,2.28-3.168,0-1.528-1.249-3.125-3.426-4.384L387.536,243.825A17.567,17.567,0,0,0,378.981,241.682Z",
    transform: "translate(-110.499 -200.483)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M129.617,388.852,509.542,608.2c4.158,2.4,10.449,2.662,14.052.582l226.714-130.9c3.6-2.079,3.149-5.71-1.009-8.112L369.374,250.43c-4.158-2.4-10.449-2.662-14.05-.582L128.608,380.741C125.008,382.82,125.459,386.451,129.617,388.852Z",
    transform: "translate(-94.029 -191.346)",
    fill: "#242993",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M126.276,344.618l20.946,10.939L357.261,234.29c3.515-2.028,9.654-1.774,13.712.568L733.233,444.01c3.465-1.94,19.272-9.541,19.272-9.541l-7.669,19.978-.031-.023a4.556,4.556,0,0,1-2.143,2.377L521.448,584.521c-3.514,2.028-9.652,1.774-13.709-.568L137.033,369.925a6.635,6.635,0,0,1-3.111-3.307l-.029.018Z",
    transform: "translate(-93.926 -207.652)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M129.617,361.006,509.542,580.357c4.158,2.4,10.449,2.661,14.052.582L750.308,450.046c3.6-2.079,3.149-5.713-1.009-8.114L369.374,222.583c-4.158-2.4-10.449-2.661-14.05-.582L128.608,352.895C125.008,354.974,125.459,358.607,129.617,361.006Z",
    transform: "translate(-94.029 -220.597)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M377.108,375.286v-4.169c0-.394-.24-.576-.537-.4l-14.7,8.483a1.288,1.288,0,0,0-.535,1.025v4.167c0,.4.24.576.535.406l14.7-8.485A1.28,1.28,0,0,0,377.108,375.286Z",
    transform: "translate(153.001 -62.974)",
    fill: "#2859cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M366.391,381.472v-4.166c0-.4-.24-.576-.537-.406l-14.7,8.485a1.285,1.285,0,0,0-.535,1.025v4.167c0,.394.24.576.535.406l14.7-8.485A1.284,1.284,0,0,0,366.391,381.472Z",
    transform: "translate(141.743 -56.474)",
    fill: "#2859cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M625.181,420.369,309.465,238.088a6.8,6.8,0,0,0-6.8,0L190.236,303.137a2.423,2.423,0,0,0,0,4.2l315.569,182.2a6.8,6.8,0,0,0,6.8,0l112.579-64.963A2.424,2.424,0,0,0,625.181,420.369Z",
    transform: "translate(-28.01 -203.18)",
    fill: "#adc8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M625.181,424.568l-1.13.652L309.463,243.592a6.8,6.8,0,0,0-6.8,0l-111.3,64.391-1.128-.652a2.423,2.423,0,0,1,0-4.2l112.425-65.045a6.8,6.8,0,0,1,6.8,0l315.719,182.28A2.425,2.425,0,0,1,625.181,424.568Z",
    transform: "translate(-28.01 -203.18)",
    fill: "#91afff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(177.86 44.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M240.307,249.265,514.552,407.6l12.194-7.04L252.5,242.225Z",
    transform: "translate(-151.999 -242.225)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M225.728,257.682,482.96,406.2l12.194-7.04L237.922,250.642Z",
    transform: "translate(-167.315 -233.382)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M216.232,263.165,519.094,438.022l12.194-7.04L228.426,256.124Z",
    transform: "translate(-177.29 -227.623)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M206.736,268.647,509.6,443.5l12.194-7.04L218.93,261.607Z",
    transform: "translate(-187.265 -221.864)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M197.24,274.13,500.1,448.987l12.194-7.04L209.434,267.089Z",
    transform: "translate(-197.24 -216.105)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M382.137,331.15l12.194,7.04,12.194-7.04-12.194-7.04Z",
    transform: "translate(-3.013 -156.207)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M361.161,335.874l25.309,14.612,12.194-7.04-25.309-14.612Z",
    transform: "translate(-25.047 -151.244)",
    fill: "#242993"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M286.725,394.73,201.6,345.583c-3.328-1.921-3.328-5.036,0-6.957l58.213-33.609a13.318,13.318,0,0,1,12.051,0l85.127,49.15c3.328,1.921,3.328,5.036,0,6.955l-58.215,33.611A13.32,13.32,0,0,1,286.725,394.73Z",
    transform: "translate(-17.427 -133.432)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M356.97,357.012l-85.127-49.15a13.318,13.318,0,0,0-12.051,0l-58.213,33.609a5.227,5.227,0,0,0-2.091,2.055c-.88-1.679-.209-3.572,2.091-4.9l58.213-33.609a13.318,13.318,0,0,1,12.051,0l85.127,49.15c2.3,1.327,2.973,3.221,2.091,4.9A5.2,5.2,0,0,0,356.97,357.012Z",
    transform: "translate(-17.411 -133.432)",
    fill: "#91afff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(282.455 22.608)",
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(-10.925 141.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M246.364,293.28,626.289,512.628c4.158,2.4,10.449,2.661,14.05.582L867.055,382.317c3.6-2.079,3.15-5.711-1.009-8.112L486.121,154.855c-4.158-2.4-10.449-2.662-14.052-.582l-226.714,130.9C241.752,287.247,242.2,290.878,246.364,293.28Z",
    transform: "translate(-242.923 -152.868)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M475.329,287.225,390.2,238.075c-3.326-1.921-3.326-5.036,0-6.955l58.215-33.611a13.326,13.326,0,0,1,12.049,0l85.129,49.15c3.326,1.921,3.326,5.036,0,6.957l-58.215,33.609A13.313,13.313,0,0,1,475.329,287.225Z",
    transform: "translate(-90.833 -107.488)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M545.577,249.5l-85.129-49.148a13.313,13.313,0,0,0-12.049,0l-58.215,33.609a5.213,5.213,0,0,0-2.091,2.055c-.88-1.679-.209-3.574,2.091-4.9L448.4,197.509a13.32,13.32,0,0,1,12.049,0l85.129,49.15c2.3,1.329,2.971,3.221,2.092,4.9A5.232,5.232,0,0,0,545.577,249.5Z",
    transform: "translate(-90.818 -107.488)",
    fill: "#91afff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(56.024 73.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M706.4,371.834,390.685,189.553a6.8,6.8,0,0,0-6.8,0L271.456,254.6a2.423,2.423,0,0,0,0,4.2L587.029,441a6.8,6.8,0,0,0,6.8,0L706.4,376.033A2.424,2.424,0,0,0,706.4,371.834Z",
    transform: "translate(-270.245 -188.643)",
    fill: "#adc8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M706.4,376.033l-1.13.652L390.685,195.059a6.8,6.8,0,0,0-6.8,0L272.588,259.454l-1.13-.652a2.423,2.423,0,0,1,0-4.2l112.425-65.047a6.8,6.8,0,0,1,6.8,0L706.4,371.834A2.424,2.424,0,0,1,706.4,376.033Z",
    transform: "translate(-270.245 -188.643)",
    fill: "#91afff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(19.737 13.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M290.766,218.648l275.045,158.8-10.9,6.29-275.045-158.8Z",
    transform: "translate(-279.871 -170.465)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M304.9,210.488,566.326,361.423l-10.9,6.29L294,216.779Z",
    transform: "translate(-265.025 -179.037)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M441.916,289.594l24.416,14.1-10.9,6.29-24.416-14.1Z",
    transform: "translate(-121.094 -95.938)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M431.4,299.842l17,9.816-10.895,6.29-17-9.816Z",
    transform: "translate(-132.142 -85.173)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M313.756,205.375l305.363,176.3-10.9,6.29-305.363-176.3Z",
    transform: "translate(-255.722 -184.408)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M322.612,200.262l305.363,176.3-10.9,6.29-305.363-176.3Z",
    transform: "translate(-246.419 -189.779)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M331.467,195.15l305.363,176.3-10.9,6.29L320.572,201.44Z",
    transform: "translate(-237.116 -195.15)",
    fill: "#242993"
  })))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M427.224,398.83l81.846-50.364L325.053,242.225,238.209,300.6Z",
    transform: "translate(23.656 104.696)",
    opacity: 0.42,
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M449.168,405.458,467.92,287.027,295.232,187.971V316.344Z",
    transform: "translate(83.557 47.704)",
    opacity: 0.42,
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(500.79 172.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M386.883,172.728,367.324,161.6l.665-4.231,19.56,11.124Z",
    transform: "translate(-341.503 -157.373)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M385.363,171.863l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-329.951 -150.804)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M388,173.362l-4.786-2.721.665-4.231,4.785,2.721Z",
    transform: "translate(-324.813 -147.882)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M377.241,172.379l-10.658-6.061.665-4.231,10.658,6.061Z",
    transform: "translate(-342.281 -152.422)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M386.3,177.53,373.238,170.1l.665-4.231,13.061,7.428Z",
    transform: "translate(-335.29 -148.446)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M385.851,177.276l-4.786-2.722.665-4.231,4.785,2.721Z",
    transform: "translate(-327.068 -143.77)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M389.458,179.327l-4.785-2.721.665-4.231,4.786,2.721Z",
    transform: "translate(-323.278 -141.615)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M373.554,175.417l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-343.058 -147.47)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M373.7,175.5l-2.635-1.5.665-4.231,2.635,1.5Z",
    transform: "translate(-337.577 -144.353)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M378.589,178.281l-4.785-2.722.665-4.231,4.785,2.722Z",
    transform: "translate(-334.696 -142.715)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M393.564,191.932,365.1,175.746l.665-4.231L394.229,187.7Z",
    transform: "translate(-343.836 -142.519)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M387.483,188.473l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-327.724 -133.356)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M372.073,184.845l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-344.614 -137.567)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M384.688,192.019l-15.109-8.592.665-4.231,15.108,8.592Z",
    transform: "translate(-339.133 -134.45)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M383.191,191.167l-4.786-2.721.665-4.231,4.785,2.722Z",
    transform: "translate(-329.862 -129.178)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M379.4,194.146l-15.777-8.972.665-4.231,15.777,8.972Z",
    transform: "translate(-345.392 -132.616)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M384.183,196.866l-11.41-6.489.665-4.231,11.41,6.489Z",
    transform: "translate(-335.778 -127.148)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M387.506,198.756l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-328.402 -122.953)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M368.209,192.917l-5.329-3.031.665-4.231,5.329,3.03Z",
    transform: "translate(-346.17 -127.664)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M373.979,196.2l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-341.909 -125.241)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M383.176,201.429l-11.347-6.453.665-4.231L383.84,197.2Z",
    transform: "translate(-336.77 -122.318)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M378.463,203.883,362.14,194.6l.665-4.231,16.323,9.283Z",
    transform: "translate(-346.948 -122.712)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M386.853,208.654l-15.294-8.7.665-4.231,15.294,8.7Z",
    transform: "translate(-337.054 -117.086)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M385.26,207.749l-4.785-2.721.665-4.231,4.785,2.722Z",
    transform: "translate(-327.688 -111.76)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M388.9,209.818l-4.786-2.722.665-4.231,4.785,2.722Z",
    transform: "translate(-323.866 -109.586)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M371.179,204.876l-9.78-5.562.665-4.231,9.78,5.562Z",
    transform: "translate(-347.726 -117.761)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M392.041,175.661l13.562,7.713.665-4.231-13.562-7.713Z",
    transform: "translate(-315.538 -142.608)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M392.717,181.18l10.657,6.061.665-4.231-10.657-6.061Z",
    transform: "translate(-314.828 -136.81)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M393.413,186.711l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-314.097 -131)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M390.963,190.453l11.216,6.379.665-4.231-11.216-6.379Z",
    transform: "translate(-316.67 -127.069)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M391.932,196.139l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-315.652 -121.097)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M390.183,200.278l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-317.49 -116.748)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M391.613,206.227l5.329,3.031.665-4.231L392.278,202Z",
    transform: "translate(-315.988 -110.499)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M388.436,209.554l10.326,5.872.665-4.231L389.1,205.323Z",
    transform: "translate(-319.325 -107.004)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M387.961,214.42l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-319.824 -101.893)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M371.785,205.22l-4.158-2.365.665-4.231,4.159,2.365Z",
    transform: "translate(-341.184 -114.041)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M380.474,210.162l-9.362-5.324.665-4.231,9.362,5.324Z",
    transform: "translate(-337.523 -111.959)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M423.887,193.684l-19.56-11.124.665-4.231,19.56,11.123Z",
    transform: "translate(-302.632 -135.36)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M422.366,192.819l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-291.08 -128.791)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M425,194.318l-4.785-2.721.665-4.231,4.786,2.722Z",
    transform: "translate(-285.941 -125.868)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M414.244,193.335l-10.658-6.061.665-4.231,10.658,6.061Z",
    transform: "translate(-303.41 -130.409)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M423.3,198.486l-13.061-7.428.665-4.231,13.061,7.428Z",
    transform: "translate(-296.419 -126.433)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M422.854,198.231l-4.785-2.721.665-4.231L423.519,194Z",
    transform: "translate(-288.197 -121.757)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M426.462,200.283l-4.785-2.721.665-4.231,4.785,2.722Z",
    transform: "translate(-284.407 -119.602)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M410.557,196.373l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-304.187 -125.457)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M410.7,196.454l-2.636-1.5.665-4.231,2.635,1.5Z",
    transform: "translate(-298.706 -122.34)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M415.593,199.237l-4.786-2.722.665-4.231,4.785,2.721Z",
    transform: "translate(-295.825 -120.701)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M430.568,212.888,402.106,196.7l.665-4.231,28.462,16.186Z",
    transform: "translate(-304.965 -120.505)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M424.486,209.429l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-288.853 -111.342)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M409.076,205.8l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-305.743 -115.554)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M421.692,212.975l-15.109-8.592.665-4.231,15.109,8.592Z",
    transform: "translate(-300.262 -112.437)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M420.194,212.123l-4.785-2.722.665-4.231,4.786,2.721Z",
    transform: "translate(-290.991 -107.164)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M416.4,215.1l-15.777-8.972.665-4.231,15.777,8.973Z",
    transform: "translate(-306.521 -110.602)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M421.187,217.822l-11.41-6.489.665-4.231,11.41,6.489Z",
    transform: "translate(-296.907 -105.135)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M424.51,219.712l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-289.531 -100.94)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M405.213,213.873l-5.329-3.03.665-4.231,5.329,3.03Z",
    transform: "translate(-307.299 -105.651)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M410.983,217.154l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-303.038 -103.228)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M420.179,222.384l-11.347-6.453.665-4.231,11.347,6.453Z",
    transform: "translate(-297.899 -100.305)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M415.467,224.839l-16.323-9.283.665-4.231,16.323,9.283Z",
    transform: "translate(-308.077 -100.699)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M423.856,229.61l-15.294-8.7.665-4.231,15.294,8.7Z",
    transform: "translate(-298.183 -95.073)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M422.264,228.7l-4.785-2.722.665-4.231,4.785,2.721Z",
    transform: "translate(-288.817 -89.746)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M425.9,230.774l-4.785-2.722.665-4.231,4.786,2.721Z",
    transform: "translate(-284.995 -87.573)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M408.183,225.832l-9.78-5.562.665-4.231,9.78,5.562Z",
    transform: "translate(-308.854 -95.747)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M429.044,196.617l13.562,7.713.665-4.231-13.562-7.713Z",
    transform: "translate(-276.667 -120.594)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M429.72,202.136l10.658,6.061.665-4.231-10.658-6.061Z",
    transform: "translate(-275.957 -114.796)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M430.417,207.667l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-275.225 -108.986)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M427.967,211.409l11.216,6.379.665-4.231-11.217-6.379Z",
    transform: "translate(-277.799 -105.056)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M428.936,217.095l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-276.781 -99.083)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M427.186,221.234l9.78,5.562.665-4.231L427.851,217Z",
    transform: "translate(-278.619 -94.734)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M428.617,227.183l5.329,3.03.665-4.231-5.329-3.03Z",
    transform: "translate(-277.116 -88.486)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M425.439,230.51l10.326,5.872.665-4.231L426.1,226.279Z",
    transform: "translate(-280.454 -84.99)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M424.965,235.375l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-280.953 -79.88)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M408.789,226.176l-4.159-2.365.665-4.231,4.159,2.365Z",
    transform: "translate(-302.313 -92.028)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M417.478,231.118l-9.362-5.324.665-4.231,9.362,5.324Z",
    transform: "translate(-298.652 -89.945)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M380.215,215.179l-19.56-11.124.665-4.231,19.56,11.124Z",
    transform: "translate(-348.508 -112.781)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M378.694,214.314l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-336.957 -106.211)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M381.329,215.812l-4.785-2.721.665-4.231,4.785,2.721Z",
    transform: "translate(-331.818 -103.289)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M370.572,214.83l-10.658-6.061.665-4.231,10.657,6.061Z",
    transform: "translate(-349.286 -107.829)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M379.63,219.981l-13.061-7.427.665-4.231,13.061,7.428Z",
    transform: "translate(-342.295 -103.853)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M379.182,219.726,374.4,217l.665-4.231,4.785,2.721Z",
    transform: "translate(-334.073 -99.177)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M382.79,221.778,378,219.057l.665-4.231,4.785,2.721Z",
    transform: "translate(-330.283 -97.022)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M366.885,217.868l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-350.064 -102.877)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M367.027,217.949l-2.635-1.5.665-4.231,2.636,1.5Z",
    transform: "translate(-344.582 -99.76)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M371.92,220.731l-4.785-2.721.665-4.231,4.786,2.722Z",
    transform: "translate(-341.701 -98.122)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M386.9,234.383,358.434,218.2l.665-4.231,28.462,16.186Z",
    transform: "translate(-350.842 -97.926)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M380.814,230.924l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-334.73 -88.763)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M365.4,227.3l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-351.62 -92.974)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M378.019,234.47l-15.108-8.592.665-4.231,15.109,8.592Z",
    transform: "translate(-346.138 -89.857)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M376.522,233.618l-4.785-2.721.665-4.231,4.785,2.722Z",
    transform: "translate(-336.867 -84.585)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M372.73,236.6l-15.777-8.973.665-4.231,15.777,8.972Z",
    transform: "translate(-352.397 -88.023)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M377.514,239.317l-11.41-6.489.665-4.231,11.41,6.489Z",
    transform: "translate(-342.784 -82.555)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M380.837,241.207l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-335.407 -78.36)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M361.541,235.368l-5.329-3.031.665-4.231,5.329,3.03Z",
    transform: "translate(-353.175 -83.071)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M367.311,238.649l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-348.914 -80.648)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M376.507,243.879l-11.347-6.453.665-4.231,11.347,6.453Z",
    transform: "translate(-343.776 -77.726)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M371.795,246.334l-16.323-9.283.665-4.231,16.323,9.283Z",
    transform: "translate(-353.953 -78.119)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M380.184,251.1l-15.294-8.7.665-4.231,15.294,8.7Z",
    transform: "translate(-344.06 -72.493)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M378.591,250.2l-4.785-2.721.665-4.231,4.786,2.722Z",
    transform: "translate(-334.694 -67.167)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M382.229,252.268l-4.785-2.721.665-4.231,4.785,2.722Z",
    transform: "translate(-330.872 -64.993)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M364.511,247.327l-9.78-5.562.665-4.231,9.78,5.562Z",
    transform: "translate(-354.731 -73.168)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M385.372,218.112l13.562,7.713.665-4.231-13.562-7.713Z",
    transform: "translate(-322.544 -98.015)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M386.048,223.631l10.657,6.061.665-4.231L386.713,219.4Z",
    transform: "translate(-321.833 -92.217)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M386.744,229.162l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-321.102 -86.407)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M384.294,232.9l11.216,6.379.665-4.231-11.216-6.379Z",
    transform: "translate(-323.676 -82.476)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M385.263,238.589l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-322.658 -76.504)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M383.514,242.729l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-324.495 -72.155)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M384.944,248.677l5.329,3.031.665-4.231-5.329-3.03Z",
    transform: "translate(-322.993 -65.906)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M381.767,252.005l10.326,5.872.665-4.231-10.326-5.872Z",
    transform: "translate(-326.331 -62.411)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M381.293,256.87l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-326.829 -57.3)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M365.116,247.671l-4.158-2.365.665-4.231,4.159,2.365Z",
    transform: "translate(-348.19 -69.448)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M373.805,252.612l-9.362-5.324.665-4.231,9.362,5.324Z",
    transform: "translate(-344.528 -67.366)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M378.726,270.343l-15.8-8.984.665-4.231,15.8,8.984Z",
    transform: "translate(-346.12 -52.585)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M379.1,270.554l-6.222-3.539.665-4.231,6.222,3.539Z",
    transform: "translate(-335.672 -46.643)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M417.218,236.134l-19.56-11.124.665-4.231,19.56,11.123Z",
    transform: "translate(-309.637 -90.767)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M415.7,235.27l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-298.085 -84.198)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M418.332,236.768l-4.786-2.721.665-4.231L419,232.537Z",
    transform: "translate(-292.947 -81.275)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M407.576,235.786l-10.658-6.061.665-4.231,10.658,6.061Z",
    transform: "translate(-310.415 -85.816)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M416.634,240.937l-13.061-7.428.665-4.231,13.061,7.428Z",
    transform: "translate(-303.424 -81.84)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M416.186,240.682l-4.786-2.721.665-4.231,4.785,2.721Z",
    transform: "translate(-295.202 -77.164)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M419.793,242.734l-4.785-2.721.665-4.231,4.786,2.722Z",
    transform: "translate(-291.412 -75.009)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M403.889,238.824l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-311.193 -80.864)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M404.031,238.9l-2.635-1.5.665-4.231,2.635,1.5Z",
    transform: "translate(-305.711 -77.747)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M408.924,241.687l-4.785-2.722.665-4.231,4.785,2.721Z",
    transform: "translate(-302.83 -76.108)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M423.9,255.338l-28.462-16.186.665-4.231,28.462,16.186Z",
    transform: "translate(-311.971 -75.912)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M417.817,251.88l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-295.858 -66.749)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M402.408,248.251l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-312.748 -70.961)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M415.023,255.425l-15.109-8.592.665-4.231,15.108,8.592Z",
    transform: "translate(-307.267 -67.844)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M413.526,254.574l-4.786-2.722.665-4.231,4.785,2.722Z",
    transform: "translate(-297.996 -62.571)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M409.733,257.552l-15.777-8.972.665-4.231,15.777,8.972Z",
    transform: "translate(-313.526 -66.009)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M414.518,260.273l-11.41-6.489.665-4.231,11.41,6.489Z",
    transform: "translate(-303.913 -60.542)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M417.841,262.163l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-296.536 -56.347)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M398.544,256.324l-5.329-3.03.665-4.231,5.329,3.03Z",
    transform: "translate(-314.304 -61.058)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M404.314,259.6l-7.042-4,.665-4.231,7.042,4.005Z",
    transform: "translate(-310.043 -58.635)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M413.511,264.835l-11.347-6.453.665-4.231,11.347,6.453Z",
    transform: "translate(-304.904 -55.712)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M408.8,267.29l-16.323-9.283.665-4.231,16.323,9.283Z",
    transform: "translate(-315.082 -56.106)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M417.187,272.061l-15.294-8.7.665-4.231,15.294,8.7Z",
    transform: "translate(-305.189 -50.48)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M415.595,271.155l-4.785-2.722.665-4.231,4.785,2.721Z",
    transform: "translate(-295.822 -45.153)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M419.233,273.224l-4.786-2.722.665-4.231,4.785,2.721Z",
    transform: "translate(-292.001 -42.98)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M401.514,268.282l-9.78-5.562.665-4.231,9.78,5.562Z",
    transform: "translate(-315.86 -51.154)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M422.375,239.068l13.562,7.713.665-4.231-13.562-7.713Z",
    transform: "translate(-283.673 -76.001)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M423.052,244.587l10.658,6.061.665-4.231-10.657-6.061Z",
    transform: "translate(-282.962 -70.203)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M423.748,250.118l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-282.231 -64.393)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M421.3,253.859l11.216,6.379.665-4.231-11.217-6.379Z",
    transform: "translate(-284.805 -60.463)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M422.267,259.545l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-283.787 -54.49)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M420.518,263.685l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-285.624 -50.141)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M421.948,269.633l5.329,3.03.665-4.231-5.329-3.03Z",
    transform: "translate(-284.122 -43.893)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M418.77,272.961l10.326,5.872.665-4.231-10.326-5.872Z",
    transform: "translate(-287.46 -40.397)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M418.3,277.826l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-287.958 -35.287)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M402.12,268.627l-4.159-2.365.665-4.231,4.159,2.365Z",
    transform: "translate(-309.319 -47.435)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M410.809,273.568l-9.362-5.324.665-4.231,9.362,5.324Z",
    transform: "translate(-305.657 -45.352)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M415.73,291.3l-15.8-8.984.665-4.231,15.8,8.984Z",
    transform: "translate(-307.249 -30.571)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M416.1,291.51l-6.223-3.539.665-4.231,6.222,3.539Z",
    transform: "translate(-296.801 -24.629)",
    fill: "#42ffff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(318.44 68.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M297.952,121.706l-19.56-11.123.665-4.231,19.56,11.124Z",
    transform: "translate(-252.572 -106.352)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M296.432,120.842l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-241.021 -99.783)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M299.066,122.34l-4.785-2.722.665-4.231,4.786,2.721Z",
    transform: "translate(-235.882 -96.86)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M288.31,121.358,277.652,115.3l.665-4.231,10.658,6.061Z",
    transform: "translate(-253.35 -101.4)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M297.368,126.509l-13.061-7.428.665-4.231,13.061,7.428Z",
    transform: "translate(-246.359 -97.425)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M296.92,126.254l-4.785-2.721.665-4.231,4.786,2.722Z",
    transform: "translate(-238.137 -92.749)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M300.527,128.306l-4.786-2.722.665-4.231,4.785,2.722Z",
    transform: "translate(-234.347 -90.594)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M284.623,124.4l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-254.128 -96.449)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M284.765,124.477l-2.636-1.5.665-4.231,2.635,1.5Z",
    transform: "translate(-248.646 -93.332)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M289.658,127.259l-4.786-2.721.665-4.231,4.785,2.721Z",
    transform: "translate(-245.765 -91.693)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M304.633,140.91l-28.462-16.186.665-4.231L305.3,136.679Z",
    transform: "translate(-254.906 -91.497)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M298.552,137.452l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-238.793 -82.334)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M283.142,133.823l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-255.683 -86.546)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M295.757,141l-15.108-8.592.665-4.231,15.109,8.592Z",
    transform: "translate(-250.202 -83.428)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M294.26,140.146l-4.785-2.721.665-4.231,4.786,2.721Z",
    transform: "translate(-240.931 -78.156)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M290.468,143.124l-15.777-8.973.665-4.231,15.777,8.973Z",
    transform: "translate(-256.461 -81.594)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M295.252,145.845l-11.41-6.489.665-4.231,11.41,6.489Z",
    transform: "translate(-246.848 -76.127)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M298.575,147.735l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-239.471 -71.932)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M279.279,141.9l-5.329-3.03.665-4.231,5.329,3.031Z",
    transform: "translate(-257.239 -76.642)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M285.048,145.177l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-252.978 -74.219)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M294.245,150.407,282.9,143.954l.665-4.231,11.347,6.453Z",
    transform: "translate(-247.84 -71.297)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M289.532,152.862l-16.323-9.283.665-4.231,16.323,9.283Z",
    transform: "translate(-258.017 -71.691)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M297.922,157.633l-15.294-8.7.665-4.231,15.294,8.7Z",
    transform: "translate(-248.124 -66.064)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M296.329,156.727l-4.785-2.721.665-4.231,4.785,2.721Z",
    transform: "translate(-238.757 -60.738)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M299.967,158.8l-4.785-2.721.665-4.231,4.786,2.721Z",
    transform: "translate(-234.935 -58.564)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M282.249,153.854l-9.78-5.562.665-4.231,9.78,5.562Z",
    transform: "translate(-258.795 -66.739)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M303.11,124.639l13.562,7.713.665-4.231-13.562-7.713Z",
    transform: "translate(-226.608 -91.586)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M303.786,130.159l10.658,6.061.665-4.231-10.658-6.061Z",
    transform: "translate(-225.897 -85.788)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M304.482,135.69l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-225.166 -79.978)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M302.032,139.431l11.216,6.379.665-4.231L302.7,135.2Z",
    transform: "translate(-227.739 -76.048)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M303,145.117l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-226.722 -70.075)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M301.252,149.257l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-228.559 -65.726)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M302.682,155.205l5.329,3.03.665-4.231-5.329-3.031Z",
    transform: "translate(-227.057 -59.478)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M299.5,158.533l10.326,5.872.665-4.231L300.169,154.3Z",
    transform: "translate(-230.395 -55.982)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M299.03,163.4l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-230.893 -50.871)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M282.854,154.2l-4.159-2.365.665-4.231,4.159,2.365Z",
    transform: "translate(-252.254 -63.019)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M291.543,159.14l-9.362-5.324.665-4.231,9.362,5.324Z",
    transform: "translate(-248.592 -60.937)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M334.956,142.662,315.4,131.539l.665-4.231,19.56,11.124Z",
    transform: "translate(-213.701 -84.339)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M333.435,141.8l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-202.149 -77.769)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M336.07,143.3l-4.785-2.721.665-4.231,4.785,2.721Z",
    transform: "translate(-197.011 -74.847)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M325.313,142.313l-10.657-6.061.665-4.231,10.658,6.061Z",
    transform: "translate(-214.479 -79.387)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M334.372,147.465l-13.061-7.428.665-4.231,13.061,7.428Z",
    transform: "translate(-207.488 -75.411)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M333.923,147.21l-4.785-2.722.665-4.231,4.785,2.721Z",
    transform: "translate(-199.266 -70.735)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M337.531,149.262l-4.785-2.722.665-4.231,4.785,2.721Z",
    transform: "translate(-195.476 -68.58)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M321.626,145.351l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-215.257 -74.435)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M321.769,145.432l-2.635-1.5.665-4.231,2.636,1.5Z",
    transform: "translate(-209.775 -71.318)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M326.661,148.215l-4.785-2.721.665-4.231,4.786,2.722Z",
    transform: "translate(-206.894 -69.68)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M341.637,161.866,313.175,145.68l.665-4.231L342.3,157.635Z",
    transform: "translate(-216.034 -69.484)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M335.555,158.407l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-199.922 -60.321)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M320.145,154.779l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-216.812 -64.532)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M332.761,161.953l-15.108-8.592.665-4.231,15.109,8.592Z",
    transform: "translate(-211.331 -61.415)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M331.263,161.1l-4.785-2.721.665-4.231,4.785,2.722Z",
    transform: "translate(-202.06 -56.143)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M327.471,164.08l-15.777-8.973.665-4.231,15.777,8.972Z",
    transform: "translate(-217.59 -59.581)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M332.256,166.8l-11.41-6.489.665-4.231,11.41,6.489Z",
    transform: "translate(-207.976 -54.113)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M335.579,168.691l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-200.6 -49.918)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M316.282,162.851l-5.329-3.031.665-4.231,5.329,3.03Z",
    transform: "translate(-218.368 -54.629)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M322.052,166.133l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-214.107 -52.206)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M331.249,171.363,319.9,164.91l.665-4.231,11.347,6.453Z",
    transform: "translate(-208.968 -49.283)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M326.536,173.818l-16.323-9.283.665-4.231,16.323,9.283Z",
    transform: "translate(-219.146 -49.677)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M334.925,178.588l-15.294-8.7.665-4.231,15.294,8.7Z",
    transform: "translate(-209.252 -44.051)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M333.333,177.683l-4.785-2.721.665-4.231L334,173.452Z",
    transform: "translate(-199.886 -38.725)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M336.971,179.752l-4.785-2.721.665-4.231,4.785,2.722Z",
    transform: "translate(-196.064 -36.551)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M319.252,174.81l-9.78-5.562.665-4.231,9.78,5.562Z",
    transform: "translate(-219.924 -44.726)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M340.113,145.6l13.562,7.713.665-4.231-13.562-7.713Z",
    transform: "translate(-187.736 -69.573)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M340.789,151.114l10.657,6.061.665-4.231-10.657-6.061Z",
    transform: "translate(-187.026 -63.775)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M341.486,156.645l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-186.295 -57.965)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M339.036,160.387l11.217,6.379.665-4.231L339.7,156.156Z",
    transform: "translate(-188.868 -54.034)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M340,166.073l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-187.85 -48.062)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M338.255,170.213l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-189.688 -43.713)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M339.686,176.161l5.329,3.031.665-4.231-5.329-3.03Z",
    transform: "translate(-188.186 -37.464)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M336.508,179.489l10.326,5.872.665-4.231-10.326-5.872Z",
    transform: "translate(-191.524 -33.969)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M336.034,184.354l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-192.022 -28.858)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M319.858,175.154,315.7,172.79l.665-4.231,4.159,2.365Z",
    transform: "translate(-213.383 -41.006)",
    fill: "#42ffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M328.547,180.1l-9.362-5.324.665-4.231,9.362,5.324Z",
    transform: "translate(-209.721 -38.924)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M291.284,164.157l-19.56-11.123.665-4.231,19.56,11.124Z",
    transform: "translate(-259.577 -61.759)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M289.763,163.292l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-248.026 -55.19)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M292.4,164.791l-4.785-2.722.665-4.231,4.785,2.721Z",
    transform: "translate(-242.887 -52.267)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M281.641,163.808l-10.658-6.061.665-4.231,10.658,6.061Z",
    transform: "translate(-260.355 -56.807)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M290.7,168.96l-13.061-7.428.665-4.231,13.061,7.428Z",
    transform: "translate(-253.364 -52.832)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M290.251,168.7l-4.785-2.721.665-4.231,4.785,2.722Z",
    transform: "translate(-245.142 -48.156)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M293.859,170.756l-4.785-2.722.665-4.231,4.785,2.722Z",
    transform: "translate(-241.352 -46.001)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M277.954,166.846l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-261.133 -51.856)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M278.1,166.927l-2.635-1.5.665-4.231,2.635,1.5Z",
    transform: "translate(-255.652 -48.739)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M282.989,169.71l-4.785-2.721.665-4.231,4.785,2.721Z",
    transform: "translate(-252.771 -47.1)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M297.964,183.361,269.5,167.175l.665-4.231,28.462,16.186Z",
    transform: "translate(-261.911 -46.904)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M291.883,179.9l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-245.799 -37.741)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M276.473,176.274l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-262.689 -41.953)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M289.089,183.448l-15.109-8.592.665-4.231,15.108,8.592Z",
    transform: "translate(-257.207 -38.835)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M287.591,182.6l-4.786-2.722.665-4.231,4.785,2.721Z",
    transform: "translate(-247.936 -33.563)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M283.8,185.574,268.022,176.6l.665-4.231,15.777,8.973Z",
    transform: "translate(-263.467 -37.001)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M288.583,188.3l-11.41-6.489.665-4.231,11.41,6.489Z",
    transform: "translate(-253.853 -31.534)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M291.906,190.185,284.2,185.8l.665-4.231,7.711,4.385Z",
    transform: "translate(-246.477 -27.339)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M272.61,184.346l-5.329-3.03.665-4.231,5.329,3.031Z",
    transform: "translate(-264.244 -32.05)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M278.38,187.627l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-259.984 -29.626)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M287.576,192.858,276.229,186.4l.665-4.231,11.347,6.453Z",
    transform: "translate(-254.845 -26.704)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M282.864,195.312l-16.323-9.283.665-4.231,16.323,9.283Z",
    transform: "translate(-265.022 -27.098)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M291.253,200.083l-15.294-8.7.665-4.231,15.294,8.7Z",
    transform: "translate(-255.129 -21.472)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M289.66,199.178l-4.786-2.721.665-4.231,4.785,2.721Z",
    transform: "translate(-245.763 -16.145)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M293.3,201.247l-4.786-2.721.665-4.231,4.785,2.721Z",
    transform: "translate(-241.941 -13.971)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M275.58,196.3l-9.78-5.562.665-4.231,9.78,5.562Z",
    transform: "translate(-265.8 -22.146)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M296.441,167.09,310,174.8l.665-4.231-13.562-7.713Z",
    transform: "translate(-233.613 -46.993)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M297.117,172.609l10.658,6.061.665-4.231-10.658-6.061Z",
    transform: "translate(-232.903 -41.195)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M297.813,178.14l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-232.171 -35.385)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M295.363,181.882l11.216,6.379.665-4.231-11.217-6.379Z",
    transform: "translate(-234.745 -31.455)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M296.332,187.568l7.711,4.385.665-4.231L297,183.337Z",
    transform: "translate(-233.727 -25.482)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M294.583,191.708l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-235.565 -21.133)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M296.013,197.656l5.329,3.03.665-4.231-5.329-3.031Z",
    transform: "translate(-234.062 -14.885)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M292.836,200.984l10.326,5.872.665-4.231L293.5,196.752Z",
    transform: "translate(-237.4 -11.389)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M292.362,205.849l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-237.898 -6.279)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M276.186,196.649l-4.159-2.365.665-4.231,4.158,2.365Z",
    transform: "translate(-259.259 -18.426)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M284.874,201.591l-9.362-5.324.665-4.231,9.362,5.324Z",
    transform: "translate(-255.598 -16.344)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M289.8,219.322,274,210.337l.665-4.231,15.8,8.984Z",
    transform: "translate(-257.19 -1.563)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M290.166,219.533l-6.223-3.539.665-4.231,6.222,3.539Z",
    transform: "translate(-246.741 4.379)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M328.287,185.113l-19.56-11.124.665-4.231,19.56,11.124Z",
    transform: "translate(-220.706 -39.746)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M326.766,184.248l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-209.155 -33.176)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M329.4,185.747l-4.785-2.721.665-4.231,4.786,2.721Z",
    transform: "translate(-204.016 -30.254)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M318.645,184.764,307.987,178.7l.665-4.231,10.658,6.061Z",
    transform: "translate(-221.484 -34.794)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M327.7,189.915l-13.061-7.428.665-4.231,13.061,7.427Z",
    transform: "translate(-214.493 -30.818)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M327.254,189.66l-4.785-2.722.665-4.231,4.786,2.721Z",
    transform: "translate(-206.271 -26.142)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M330.862,191.712l-4.786-2.722.665-4.231,4.785,2.721Z",
    transform: "translate(-202.481 -23.987)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M314.958,187.8l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-222.262 -29.842)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M315.1,187.883l-2.636-1.5.665-4.231,2.635,1.5Z",
    transform: "translate(-216.781 -26.725)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M319.993,190.665l-4.786-2.721.665-4.231,4.785,2.722Z",
    transform: "translate(-213.899 -25.087)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M334.968,204.317l-28.462-16.186.665-4.231,28.462,16.186Z",
    transform: "translate(-223.04 -24.891)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M328.886,200.858l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-206.928 -15.728)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M313.477,197.229l-7.711-4.385.665-4.231L314.141,193Z",
    transform: "translate(-223.818 -19.939)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M326.092,204.4l-15.108-8.592.665-4.231,15.109,8.592Z",
    transform: "translate(-218.336 -16.822)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M324.595,203.552l-4.785-2.721.665-4.231,4.786,2.721Z",
    transform: "translate(-209.065 -11.55)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M320.8,206.53l-15.777-8.973.665-4.231,15.777,8.972Z",
    transform: "translate(-224.595 -14.988)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M325.587,209.251l-11.41-6.489.665-4.231,11.41,6.489Z",
    transform: "translate(-214.982 -9.52)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M328.91,211.141l-7.711-4.385.665-4.231,7.711,4.385Z",
    transform: "translate(-207.605 -5.326)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M309.613,205.3l-5.329-3.031.665-4.231,5.329,3.03Z",
    transform: "translate(-225.373 -10.036)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M315.383,208.583l-7.042-4,.665-4.231,7.042,4Z",
    transform: "translate(-221.112 -7.613)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M324.58,213.813l-11.347-6.453.665-4.231,11.347,6.453Z",
    transform: "translate(-215.974 -4.691)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M319.867,216.268l-16.323-9.283.665-4.231,16.323,9.283Z",
    transform: "translate(-226.151 -5.085)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M328.256,221.039l-15.294-8.7.665-4.231,15.294,8.7Z",
    transform: "translate(-216.258 0.542)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M326.664,220.133l-4.785-2.721.665-4.231,4.785,2.722Z",
    transform: "translate(-206.892 5.868)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M330.3,222.2l-4.785-2.721.665-4.231,4.786,2.722Z",
    transform: "translate(-203.07 8.042)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M312.584,217.261,302.8,211.7l.665-4.231,9.78,5.562Z",
    transform: "translate(-226.929 -0.133)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M333.444,188.046l13.562,7.713.665-4.231-13.562-7.713Z",
    transform: "translate(-194.742 -24.98)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M334.121,193.565l10.657,6.061.665-4.231-10.658-6.061Z",
    transform: "translate(-194.032 -19.182)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M334.817,199.1l7.711,4.385.665-4.231-7.711-4.385Z",
    transform: "translate(-193.3 -13.372)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M332.367,202.838l11.216,6.379.665-4.231-11.216-6.379Z",
    transform: "translate(-195.874 -9.442)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M333.336,208.523l7.711,4.385.665-4.231L334,204.292Z",
    transform: "translate(-194.856 -3.469)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M331.587,212.663l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-196.693 0.88)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M333.017,218.611l5.329,3.031.665-4.231-5.329-3.03Z",
    transform: "translate(-195.191 7.129)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M329.84,221.939l10.326,5.872.665-4.231L330.5,217.708Z",
    transform: "translate(-198.529 10.624)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M329.365,226.8l9.78,5.562.665-4.231-9.78-5.562Z",
    transform: "translate(-199.027 15.735)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M313.189,217.605l-4.159-2.365.665-4.231,4.159,2.365Z",
    transform: "translate(-220.388 3.587)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M321.878,222.546l-9.362-5.324.665-4.231,9.362,5.324Z",
    transform: "translate(-216.726 5.669)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M326.8,240.278,311,231.293l.665-4.231,15.8,8.984Z",
    transform: "translate(-218.319 20.45)",
    fill: "#42ffff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M327.17,240.489l-6.222-3.539.665-4.231,6.223,3.539Z",
    transform: "translate(-207.87 26.392)",
    fill: "#42ffff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(67.223 167.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(292.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M286.419,165.358l18.27-10.523v.014a.837.837,0,0,1,.912.039l228.92,132.167a3.237,3.237,0,0,1,1.353,2.586v43.214a1.284,1.284,0,0,1-.375,1.017l.006,0-.014.008c-.016.012-.037.018-.055.033l-18.454,10.63-.146-20.88L305.6,201.71a3.242,3.242,0,0,1-1.353-2.586V184.294Z",
    transform: "translate(-285.882 -154.732)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M287.51,206.868l228.92,132.167c.746.433,1.353-.027,1.353-1.023V294.8a3.242,3.242,0,0,0-1.353-2.586L287.51,160.046c-.746-.431-1.353.027-1.353,1.023v43.214A3.242,3.242,0,0,0,287.51,206.868Z",
    transform: "translate(-286.157 -149.32)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M310.838,178.529,489.083,283.337a122.841,122.841,0,0,0-15.512,16.131L294.01,195.8A121.663,121.663,0,0,1,310.838,178.529Z",
    transform: "translate(-277.908 -129.734)",
    fill: "#242993",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M290.476,183.35,506.335,307.978c.511.293.925-.018.925-.7V296.421a2.217,2.217,0,0,0-.925-1.768L290.476,170.026c-.511-.293-.925.018-.925.7v10.855A2.214,2.214,0,0,0,290.476,183.35Z",
    transform: "translate(-282.592 -138.781)",
    fill: "#242993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M290.476,170.026l4.39,2.536v5.86a2.21,2.21,0,0,0,.925,1.765L507.259,302.282v5c0,.681-.414.992-.925.7L290.476,183.35a2.214,2.214,0,0,1-.925-1.767V170.726C289.551,170.045,289.965,169.733,290.476,170.026Z",
    transform: "translate(-282.592 -138.781)",
    fill: "#4553c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M322.863,645.169l-179.58-103.68h0c23.166-13.375,42.693-42.648,48.658-70.641a40.842,40.842,0,0,1,19.408-27l135.7-78.336a129.861,129.861,0,0,0,64.864-104.672c2.169-36.785,29.978-72.96,51.563-85.422h0L643.054,279.1h0c-21.263,12.278-44.674,46.589-47.339,82.749-3.211,43.564-26.9,82.993-64.735,104.832l-140.053,80.85a40.849,40.849,0,0,0-19.408,27c-5.965,27.993-25.489,57.268-48.655,70.643Z",
    transform: "translate(-143.283 -133.003)",
    opacity: 0.96,
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M301.625,175.417,481.2,279.1c-1.439.832-2.862,1.733-4.275,2.666l-.012-.01L297.358,178.076C298.769,177.146,300.19,176.247,301.625,175.417Z",
    transform: "translate(18.568 -133.003)",
    fill: "#4553c7",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(364.285 281.538)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M332.372,237.047,363.864,255.3l.255-3.632L332.682,233.49Z",
    transform: "translate(-241.713 -186.018)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M324.629,232.541l11.128,6.449.317-3.547-11.109-6.423Z",
    transform: "translate(-249.847 -190.713)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M318.689,229.084l7.485,4.338.344-3.51-7.472-4.321Z",
    transform: "translate(-256.086 -194.315)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M339,245.131l17.316,10.09.257-3.662L339.287,241.51Z",
    transform: "translate(-234.751 -177.593)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M326.478,237.8l20.859,12.154.3-3.61-20.823-12.1Z",
    transform: "translate(-247.905 -185.227)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M320.5,234.3l7.539,4.393.339-3.55-7.526-4.375Z",
    transform: "translate(-254.189 -188.874)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M314.851,231l7.475,4.356.359-3.522-7.463-4.338Z",
    transform: "translate(-260.118 -192.315)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M341.012,250.578l12.6,7.382.259-3.694-12.578-7.351Z",
    transform: "translate(-232.638 -171.915)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M336.565,247.962l4.266,2.5.29-3.652-4.259-2.489Z",
    transform: "translate(-237.309 -174.641)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M330.465,244.374l7.686,4.5.305-3.63-7.672-4.484Z",
    transform: "translate(-243.716 -178.379)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M324.366,245.041,370.5,272.213l.261-3.725-46.056-27.061Z",
    transform: "translate(-250.123 -177.68)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M316.612,240.455l11.143,6.563.35-3.6-11.124-6.536Z",
    transform: "translate(-258.268 -182.458)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M340.378,258.857l12.7,7.522.264-3.757-12.68-7.491Z",
    transform: "translate(-233.303 -163.284)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M326.058,250.341l24.472,14.491.295-3.714L326.4,246.687Z",
    transform: "translate(-248.346 -172.155)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M320,246.738l7.635,4.521.345-3.643-7.622-4.5Z",
    transform: "translate(-254.711 -175.909)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M333.611,259.2l25.972,15.463.266-3.789-25.926-15.4Z",
    transform: "translate(-240.412 -162.928)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M322.255,252.406l18.42,10.966.321-3.714-18.388-10.921Z",
    transform: "translate(-252.34 -170.001)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M313.94,247.434l12.268,7.3.36-3.657-12.247-7.274Z",
    transform: "translate(-261.076 -175.18)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M341.657,268.436l8.862,5.3.268-3.822-8.846-5.283Z",
    transform: "translate(-231.959 -153.3)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M333.6,263.589l11.585,6.935.293-3.788-11.565-6.906Z",
    transform: "translate(-240.428 -158.349)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M322.238,256.761l18.4,11.015.322-3.747-18.369-10.969Z",
    transform: "translate(-252.359 -165.461)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M332.471,267.352l27.081,16.3.271-3.855L332.79,263.565Z",
    transform: "translate(-241.609 -154.425)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M317.979,258.592l24.815,14.935.327-3.775L318.35,254.878Z",
    transform: "translate(-256.832 -163.55)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M311.911,254.924l7.646,4.6.379-3.7-7.633-4.583Z",
    transform: "translate(-263.207 -167.371)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M306.139,251.435l7.58,4.562.4-3.673-7.567-4.544Z",
    transform: "translate(-269.27 -171.006)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M337.4,274.827l16.355,9.9.273-3.889L337.7,270.979Z",
    transform: "translate(-236.433 -146.637)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M312.75,225.578l-20.483-11.871.445-3.368,20.45,11.824Z",
    transform: "translate(-283.842 -210.338)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M307.9,226.892l-16.129-9.4.449-3.4,16.1,9.361Z",
    transform: "translate(-284.366 -206.387)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M302.959,228.164l-11.694-6.85.453-3.423,11.675,6.823Z",
    transform: "translate(-284.895 -202.405)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M307.865,235.239l-17.107-10.075.456-3.451,17.079,10.035Z",
    transform: "translate(-285.428 -198.389)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M302.027,236.022l-11.781-6.976.46-3.479,11.762,6.948Z",
    transform: "translate(-285.965 -194.341)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M304.746,241.9l-15.015-8.939.464-3.508,14.991,8.9Z",
    transform: "translate(-286.506 -190.259)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M297.4,241.81l-8.191-4.9.468-3.537,8.178,4.884Z",
    transform: "translate(-287.052 -186.144)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M304.665,250.5l-15.978-9.617.472-3.567L305.11,246.9Z",
    transform: "translate(-287.603 -181.995)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M303.345,254.09l-15.186-9.19.475-3.6,15.161,9.153Z",
    transform: "translate(-288.158 -177.811)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M331.629,271.32l6.872,4.159.311-3.835-6.86-4.141Z",
    transform: "translate(-242.494 -150.289)",
    fill: "#4553c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M321.772,265.329l15.293,9.255.332-3.805-15.266-9.216Z",
    transform: "translate(-252.848 -156.529)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M221.779,238.579,156.63,200.963l65.149-37.612,65.149,37.614Zm-61.6-37.616,61.6,35.565,61.6-35.563-61.6-35.563Z",
    transform: "translate(127.754 228.328)",
    fill: "#88fff3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(367.623 624.129)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(156.466 18.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M277.816,285.688l4.566,2.3L278.1,290.31l-4.566-2.3Z",
    transform: "translate(-273.532 -285.688)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(161.032 20.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M280.043,286.81l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-275.759 -286.81)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(179.297 29.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M288.95,291.3l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-284.667 -291.296)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(183.863 32.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M291.177,292.418l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-286.894 -292.418)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(188.43 34.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M293.4,293.539l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-289.121 -293.539)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(202.129 41.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M300.085,296.9l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-295.802 -296.904)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(206.695 43.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M302.312,298.026l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-298.029 -298.026)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(211.261 45.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M304.539,299.148l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-300.256 -299.148)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54",
    transform: "translate(152.182 20.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M275.727,286.821l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-271.443 -286.821)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(161.315 25.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M280.181,289.064l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-275.897 -289.064)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(175.014 32.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M286.861,292.429l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-282.578 -292.429)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(188.713 39.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M293.542,295.794l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-289.259 -295.794)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(193.279 41.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M295.769,296.915l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-291.486 -296.915)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(206.978 48.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M302.45,300.28l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-298.167 -300.28)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(157.031 27.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M278.092,290.2l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-273.808 -290.196)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(166.164 32.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M282.546,292.44l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-278.262 -292.44)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(184.429 41.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M291.453,296.926l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-287.17 -296.926)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(193.562 46.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M295.907,299.169l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-291.624 -299.169)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(202.695 50.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M300.361,301.413l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-296.078 -301.413)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(143.615 25.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M271.549,289.086l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-267.265 -289.086)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(148.182 27.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M273.776,290.207l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-269.492 -290.207)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(152.748 29.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M276,291.329l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-271.719 -291.329)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(171.013 39.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M284.91,295.815l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-280.627 -295.815)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(175.58 41.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M287.137,296.937l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-282.854 -296.937)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(184.712 46.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M291.591,299.18l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-287.308 -299.18)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(198.411 52.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M298.272,302.545l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-293.989 -302.545)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(153.031 34.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M276.141,293.583l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-271.857 -293.583)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(166.73 41.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M282.822,296.948l4.566,2.3L283.1,301.57l-4.566-2.3Z",
    transform: "translate(-278.538 -296.948)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(175.863 46.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M287.275,299.191l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-282.992 -299.191)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(189.562 52.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M293.956,302.556l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-289.673 -302.556)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(139.615 32.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M269.6,292.472l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-265.314 -292.472)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(153.314 39.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M276.279,295.837l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-271.995 -295.837)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(157.88 41.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M278.506,296.959l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-274.222 -296.959)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(167.013 46.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M282.959,299.2l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-278.676 -299.202)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    transform: "translate(171.579 48.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M285.186,300.323l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-280.903 -300.323)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(176.145 50.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M287.413,301.445l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-283.13 -301.445)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110",
    transform: "translate(180.712 53.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M289.64,302.567l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-285.357 -302.567)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(185.278 55.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M291.867,303.688l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-287.584 -303.688)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(189.844 57.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M294.094,304.81l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-289.811 -304.81)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(130.765 32.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M265.282,292.483l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-260.998 -292.483)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(139.898 36.932)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M269.736,294.726l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-265.452 -294.726)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(149.031 41.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M274.19,296.97l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-269.906 -296.97)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(158.163 46.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M278.644,299.213l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-274.36 -299.213)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(167.296 50.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M283.1,301.456l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-278.814 -301.456)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(176.428 55.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M287.551,303.7l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-283.268 -303.699)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(185.561 59.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M292.005,305.942l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-287.722 -305.942)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(126.482 34.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M263.193,293.616l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-258.909 -293.616)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132",
    transform: "translate(131.048 36.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M265.42,294.737l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-261.136 -294.737)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(144.747 43.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M272.1,298.1l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-267.817 -298.102)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(158.446 50.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M278.782,301.467l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-274.498 -301.467)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(163.012 53.053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M281.009,302.588l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-276.725 -302.588)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(167.579 55.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M283.235,303.71l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-278.952 -303.71)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(176.711 59.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M287.689,305.953l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-283.406 -305.953)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(85.668 18.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M243.288,285.775l4.566,2.3-4.283,2.322L239,288.1Z",
    transform: "translate(-239.005 -285.775)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(94.801 23.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M247.742,288.018l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-243.459 -288.018)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(99.367 25.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M249.969,289.14l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-245.686 -289.14)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(108.5 30.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M254.423,291.383l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-250.14 -291.383)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(113.066 32.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M256.65,292.5l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-252.367 -292.505)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(117.632 34.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M258.877,293.626l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-254.594 -293.626)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(131.331 41.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M265.558,296.991l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-261.274 -296.991)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(145.03 48.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M272.239,300.356l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-267.955 -300.356)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(154.163 53.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M276.693,302.6l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-272.409 -302.599)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(163.295 57.675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M281.146,304.843l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-276.863 -304.843)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(186.127 69.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M292.281,310.451l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-287.998 -310.451)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(199.826 76.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M298.962,313.815l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-294.679 -313.815)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(208.958 80.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M303.416,316.059l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-299.133 -316.059)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(213.525 82.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M305.643,317.18l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-301.36 -317.18)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(95.084 27.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M247.88,290.273l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-243.597 -290.273)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(104.216 32.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M252.334,292.516l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-248.051 -292.516)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(113.349 36.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M256.788,294.759l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-252.505 -294.759)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(117.915 39.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M259.015,295.881l4.566,2.3L259.3,300.5l-4.566-2.3Z",
    transform: "translate(-254.732 -295.881)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(122.481 41.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M261.242,297l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-256.958 -297.002)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(127.048 43.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M263.469,298.124l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-259.185 -298.124)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(136.18 48.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M267.923,300.367l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-263.639 -300.367)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(140.747 50.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M270.15,301.489l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-265.866 -301.489)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(145.313 53.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M272.377,302.61l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-268.093 -302.61)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(149.879 55.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M274.6,303.732l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-270.32 -303.732)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(159.012 59.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M279.057,305.975l4.566,2.3L279.34,310.6l-4.566-2.3Z",
    transform: "translate(-274.774 -305.975)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(163.578 62.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M281.284,307.1l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-277.001 -307.097)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(168.145 64.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M283.511,308.218l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-279.228 -308.218)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(172.711 66.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M285.738,309.34l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-281.455 -309.34)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(177.277 69.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M287.965,310.461l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-283.682 -310.461)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(181.844 71.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M290.192,311.583l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-285.909 -311.583)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(186.41 73.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M292.419,312.7l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-288.136 -312.705)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(190.976 76.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M294.646,313.826l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-290.363 -313.826)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(209.241 85.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M303.554,318.313l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-299.271 -318.313)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(77.101 23.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M239.11,288.04l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-234.827 -288.04)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(95.367 32.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M248.018,292.527l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-243.735 -292.527)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(99.933 34.721)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M250.245,293.648l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-245.962 -293.648)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(104.499 37.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M252.472,294.77l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-248.189 -294.77)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(113.632 41.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M256.926,297.013l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-252.643 -297.013)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(118.198 43.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M259.153,298.135l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-254.869 -298.135)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(127.331 48.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M263.607,300.378l4.566,2.3L263.89,305l-4.566-2.3Z",
    transform: "translate(-259.323 -300.378)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(131.897 50.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M265.834,301.5l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-261.55 -301.5)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(136.463 53.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M268.061,302.621l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-263.777 -302.621)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(150.162 60.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M274.742,305.986l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-270.458 -305.986)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(159.295 64.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M279.2,308.229l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-274.912 -308.229)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(168.428 69.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M283.649,310.472l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-279.366 -310.472)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(172.994 71.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M285.876,311.594l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-281.593 -311.594)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(195.825 83.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M297.011,317.2l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-292.728 -317.202)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(200.392 85.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M299.238,318.324l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-294.955 -318.324)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(72.818 25.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M237.021,289.173l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-232.738 -289.173)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(77.384 27.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M239.248,290.294l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-234.965 -290.294)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(81.951 30.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M241.475,291.416l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-237.192 -291.416)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(109.348 43.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M254.837,298.146l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-250.554 -298.146)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(123.047 50.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M261.518,301.51l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-257.234 -301.51)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(145.879 62.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M272.653,307.118l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-268.369 -307.118)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(177.843 78.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M288.241,314.97l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-283.958 -314.97)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(186.976 83.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M292.7,317.213l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-288.412 -317.213)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(200.675 89.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M299.376,320.578l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-295.093 -320.578)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(73.101 30.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M237.159,291.427l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-232.876 -291.427)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(86.8 37.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M243.84,294.792l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-239.557 -294.792)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(91.366 39.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M246.067,295.913l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-241.784 -295.913)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(95.932 41.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M248.294,297.035l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-244.011 -297.035)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(123.33 55.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M261.656,303.764l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-257.372 -303.764)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(132.463 60.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M266.11,306.008l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-261.826 -306.008)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(137.029 62.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M268.337,307.129l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-264.053 -307.129)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(146.162 66.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M272.791,309.373l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-268.507 -309.373)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(155.294 71.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M277.245,311.616l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-272.961 -311.616)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(159.861 73.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M279.471,312.737l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-275.188 -312.737)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(182.692 85.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M290.606,318.345l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-286.323 -318.345)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(187.259 87.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M292.833,319.467l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-288.55 -319.467)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(64.251 30.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M232.843,291.438l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-228.56 -291.438)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284",
    transform: "translate(73.384 34.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M237.3,293.681l4.566,2.3L237.58,298.3l-4.566-2.3Z",
    transform: "translate(-233.014 -293.681)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(77.95 37.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M239.524,294.8l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-235.241 -294.802)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(82.516 39.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M241.751,295.924l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-237.468 -295.924)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(87.083 41.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M243.978,297.046l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-239.695 -297.046)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(96.215 46.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M248.432,299.289l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-244.149 -299.289)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(109.914 53.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M255.113,302.654l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-250.829 -302.654)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(114.481 55.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M257.34,303.775l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-253.057 -303.775)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(128.18 62.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M264.021,307.14l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-259.737 -307.14)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(137.312 66.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M268.475,309.383l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-264.191 -309.383)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(141.879 69.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M270.7,310.505l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-266.418 -310.505)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(151.011 73.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M275.156,312.748l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-270.872 -312.748)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(164.71 80.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M281.836,316.113l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-277.553 -316.113)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(187.542 92.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M292.971,321.721l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-288.688 -321.721)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(192.108 94.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M295.2,322.843l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-290.915 -322.843)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(59.968 32.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M230.754,292.57l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-226.471 -292.57)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(64.534 34.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M232.981,293.692l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-228.698 -293.692)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(87.366 46.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M244.116,299.3l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-239.833 -299.3)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(101.065 53.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M250.8,302.665l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-246.514 -302.665)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(110.197 57.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M255.251,304.908l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-250.968 -304.908)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(119.33 62.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M259.7,307.151l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-255.421 -307.151)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(128.463 67.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M264.159,309.394l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-259.875 -309.394)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(133.029 69.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M266.386,310.516l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-262.102 -310.516)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(137.595 71.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M268.613,311.638l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-264.329 -311.638)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330",
    transform: "translate(142.161 73.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M270.84,312.759l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-266.556 -312.759)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332",
    transform: "translate(146.728 76.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M273.067,313.881l4.566,2.3L273.35,318.5l-4.566-2.3Z",
    transform: "translate(-268.783 -313.881)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(151.294 78.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M275.294,315l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-271.01 -315.002)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(164.993 85.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M281.974,318.367l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-277.691 -318.367)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(174.126 90.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M286.428,320.61l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-282.145 -320.61)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340",
    transform: "translate(178.692 92.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M288.655,321.732l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-284.372 -321.732)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342",
    transform: "translate(183.258 94.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M290.882,322.854l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-286.599 -322.854)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344",
    transform: "translate(187.825 96.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M293.109,323.975l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-288.826 -323.975)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(92.215 53.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M246.481,302.676l4.566,2.3-4.283,2.322L242.2,305Z",
    transform: "translate(-242.198 -302.676)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348",
    transform: "translate(101.348 57.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M250.935,304.919l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-246.652 -304.919)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350",
    transform: "translate(119.613 67.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M259.843,309.405l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-255.559 -309.405)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(128.745 71.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M264.3,311.648l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-260.013 -311.648)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354",
    transform: "translate(178.975 96.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M288.793,323.986l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-284.51 -323.986)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356",
    transform: "translate(55.967 39.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M228.8,295.957l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-224.52 -295.957)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358",
    transform: "translate(60.534 41.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M231.03,297.078l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-226.747 -297.078)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(74.233 48.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M237.711,300.443l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-233.428 -300.443)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(78.799 50.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M239.938,301.565l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-235.655 -301.565)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(97.064 60.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M248.846,306.051l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-244.563 -306.051)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(101.631 62.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M251.073,307.173l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-246.79 -307.173)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(115.329 69.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M257.754,310.538l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-253.47 -310.538)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(119.896 71.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M259.981,311.659l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-255.697 -311.659)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(133.595 78.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M266.662,315.024l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-262.378 -315.024)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(138.161 80.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M268.889,316.146l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-264.605 -316.146)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    transform: "translate(142.727 83.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M271.116,317.267l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-266.832 -317.267)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    transform: "translate(147.294 85.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M273.343,318.389l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-269.059 -318.389)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(156.426 90.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M277.8,320.632l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-273.513 -320.632)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    transform: "translate(160.993 92.351)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M280.023,321.754l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-275.74 -321.754)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    transform: "translate(174.691 99.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M286.7,325.119l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-282.421 -325.119)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(65.383 48.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M233.4,300.454l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-229.112 -300.454)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    transform: "translate(79.082 55.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M240.076,303.819l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-235.793 -303.819)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(83.648 57.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M242.3,304.941l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-238.02 -304.941)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392",
    transform: "translate(101.913 67.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M251.211,309.427l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-246.928 -309.427)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(111.046 71.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M255.665,311.67l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-251.382 -311.67)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396",
    transform: "translate(120.179 76.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M260.119,313.913l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-255.835 -313.913)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398",
    transform: "translate(124.745 78.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M262.346,315.035l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-258.062 -315.035)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(138.444 85.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M269.027,318.4l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-264.743 -318.4)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(143.01 87.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M271.254,319.521l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-266.97 -319.521)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404",
    transform: "translate(152.143 92.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M275.708,321.765l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-271.424 -321.765)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(165.842 99.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M282.388,325.13l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-278.105 -325.13)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(170.408 101.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M284.615,326.251l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-280.332 -326.251)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(42.834 41.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M222.4,297.1l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-218.115 -297.1)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(51.967 46.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M226.852,299.343l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-222.569 -299.343)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(61.1 50.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M231.306,301.587l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-227.023 -301.587)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(65.666 53.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M233.533,302.708l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-229.25 -302.708)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    transform: "translate(70.232 55.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M235.76,303.83l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-231.477 -303.83)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(79.365 60.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M240.214,306.073l4.566,2.3L240.5,310.7l-4.566-2.3Z",
    transform: "translate(-235.931 -306.073)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    transform: "translate(97.63 69.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M249.122,310.559l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-244.839 -310.559)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    transform: "translate(102.196 71.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M251.349,311.681l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-247.066 -311.681)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(106.763 73.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M253.576,312.8l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-249.293 -312.803)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(111.329 76.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M255.8,313.924l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-251.519 -313.924)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(115.895 78.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M258.03,315.046l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-253.746 -315.046)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(120.462 80.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M260.257,316.168l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-255.973 -316.168)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434",
    transform: "translate(138.727 90.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M269.165,320.654l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-264.881 -320.654)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(152.426 96.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M275.845,324.019l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-271.562 -324.019)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(156.992 99.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M278.072,325.14l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-273.789 -325.14)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    transform: "translate(161.558 101.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M280.3,326.262l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-276.016 -326.262)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(79.648 64.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M240.352,308.327l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-236.069 -308.327)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(93.347 71.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M247.033,311.692l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-242.75 -311.692)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    transform: "translate(97.913 74.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M249.26,312.814l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-244.977 -312.814)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    transform: "translate(102.479 76.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M251.487,313.935l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-247.204 -313.935)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450",
    transform: "translate(107.046 78.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M253.714,315.057l4.566,2.3L254,319.679l-4.566-2.3Z",
    transform: "translate(-249.43 -315.057)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452",
    transform: "translate(111.612 80.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M255.941,316.178l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-251.657 -316.178)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(116.178 83.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M258.168,317.3l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-253.884 -317.3)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456",
    transform: "translate(120.745 85.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M260.395,318.422l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-256.111 -318.422)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    transform: "translate(134.443 92.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M267.076,321.786l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-262.792 -321.786)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460",
    transform: "translate(139.01 94.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M269.3,322.908l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-265.019 -322.908)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(157.275 103.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M278.21,327.395l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-273.927 -327.395)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464",
    transform: "translate(38.834 48.743)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M220.447,300.487l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-216.164 -300.487)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466",
    transform: "translate(47.966 53.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M224.9,302.73l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-220.618 -302.73)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468",
    transform: "translate(61.665 60.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M231.582,306.095l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-227.299 -306.095)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(66.232 62.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M233.809,307.216l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-229.526 -307.216)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(93.63 76.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M247.171,313.946l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-242.888 -313.946)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(98.196 78.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M249.4,315.068l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-245.115 -315.068)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(102.762 80.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M251.625,316.189l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-247.341 -316.189)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(107.329 83.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M253.852,317.311l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-249.568 -317.311)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(111.895 85.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M256.079,318.432l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-251.795 -318.432)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(116.461 87.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M258.306,319.554l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-254.022 -319.554)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484",
    transform: "translate(125.594 92.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M262.76,321.8l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-258.476 -321.797)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(130.16 94.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M264.987,322.919l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-260.703 -322.919)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(134.726 97.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M267.214,324.041l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-262.93 -324.041)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(139.293 99.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M269.441,325.162l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-265.157 -325.162)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(143.859 101.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M271.667,326.284l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-267.384 -326.284)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(148.425 103.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M273.894,327.405l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-269.611 -327.405)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    transform: "translate(152.992 106.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M276.121,328.527l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-271.838 -328.527)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "translate(66.515 67.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M233.947,309.47l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-229.664 -309.47)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(71.081 69.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M236.174,310.592l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-231.891 -310.592)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502",
    transform: "translate(75.647 71.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M238.4,311.714l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-234.118 -311.714)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    transform: "translate(80.214 74.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M240.628,312.835l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-236.345 -312.835)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(121.31 94.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M260.671,322.93l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-256.387 -322.93)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    transform: "translate(139.576 103.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M269.579,327.416l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-265.295 -327.416)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(144.142 106.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M271.806,328.538l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-267.522 -328.538)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512",
    transform: "translate(148.708 108.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M274.032,329.66l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-269.749 -329.66)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514",
    transform: "translate(153.275 110.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M276.259,330.781l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-271.976 -330.781)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    transform: "translate(157.841 113.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M278.486,331.9l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-274.203 -331.903)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518",
    transform: "translate(62.231 69.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M231.858,310.6l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-227.575 -310.603)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520",
    transform: "translate(80.497 78.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M240.766,315.089l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-236.483 -315.089)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522",
    transform: "translate(89.629 83.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M245.22,317.333l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-240.937 -317.333)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    transform: "translate(98.762 87.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M249.674,319.576l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-245.391 -319.576)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    transform: "translate(107.894 92.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M254.128,321.819l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-249.844 -321.819)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    transform: "translate(112.461 94.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M256.355,322.941l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-252.071 -322.941)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530",
    transform: "translate(117.027 97.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M258.582,324.062l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-254.298 -324.062)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532",
    transform: "translate(126.16 101.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M263.036,326.306l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-258.752 -326.306)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534",
    transform: "translate(135.292 106.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M267.49,328.549l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-263.206 -328.549)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536",
    transform: "translate(139.859 108.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M269.717,329.67l4.566,2.3L270,334.292l-4.566-2.3Z",
    transform: "translate(-265.433 -329.67)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538",
    transform: "translate(148.991 113.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M274.171,331.914l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-269.887 -331.914)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    transform: "translate(57.948 71.808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M229.769,311.735l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-225.486 -311.735)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "translate(62.514 74.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M232,312.857l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-227.713 -312.857)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(67.081 76.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M234.223,313.979l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-229.94 -313.979)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    transform: "translate(76.213 81.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M238.677,316.222l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-234.394 -316.222)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(80.78 83.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M240.9,317.344l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-236.621 -317.344)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    transform: "translate(85.346 85.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M243.131,318.465l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-238.848 -318.465)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552",
    transform: "translate(89.912 87.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M245.358,319.587l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-241.075 -319.587)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(94.478 90.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M247.585,320.708l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-243.302 -320.708)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(112.744 99.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M256.493,325.195l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-252.209 -325.195)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(131.009 108.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M265.4,329.681l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-261.117 -329.681)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(149.274 117.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M274.308,334.168l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-270.025 -334.168)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(62.797 78.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M232.134,315.111l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-227.851 -315.111)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(67.364 81.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M234.361,316.233l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-230.078 -316.233)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(71.93 83.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M236.588,317.354l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-232.305 -317.354)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(85.629 90.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M243.269,320.719l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-238.986 -320.719)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(90.195 92.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M245.5,321.841l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-241.213 -321.841)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(94.761 94.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M247.723,322.962l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-243.44 -322.962)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(99.328 97.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M249.95,324.084l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-245.667 -324.084)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(108.46 101.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M254.4,326.327l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-250.12 -326.327)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(113.027 104.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M256.631,327.449l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-252.347 -327.449)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(117.593 106.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M258.858,328.57l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-254.574 -328.57)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    transform: "translate(122.159 108.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M261.085,329.692l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-256.801 -329.692)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(126.726 110.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M263.312,330.814l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-259.028 -330.814)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(135.858 115.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M267.766,333.057l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-263.482 -333.057)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(140.425 117.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M269.993,334.179l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-265.709 -334.179)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(49.381 76.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M225.591,314l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-221.308 -314)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(58.514 81.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M230.045,316.244l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-225.762 -316.244)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(67.646 85.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M234.5,318.487l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-230.216 -318.487)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(72.213 87.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M236.726,319.609l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-232.443 -319.609)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(81.345 92.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M241.18,321.852l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-236.897 -321.852)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(85.912 94.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M243.407,322.973l4.566,2.3L243.69,327.6l-4.566-2.3Z",
    transform: "translate(-239.124 -322.973)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(99.611 101.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M250.088,326.338l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-245.804 -326.338)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(104.177 104.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M252.315,327.46l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-248.031 -327.46)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(108.743 106.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M254.542,328.581l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-250.258 -328.581)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(117.876 110.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M259,330.825l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-254.712 -330.825)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(122.442 113.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M261.223,331.946l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-256.939 -331.946)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(131.575 117.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M265.677,334.189l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-261.393 -334.189)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614",
    transform: "translate(140.707 122.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M270.13,336.433l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-265.847 -336.433)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(45.098 78.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M223.5,315.133l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-219.219 -315.133)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    transform: "translate(54.23 83.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M227.956,317.376l4.566,2.3L228.239,322l-4.566-2.3Z",
    transform: "translate(-223.673 -317.376)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(58.797 85.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M230.183,318.5l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-225.9 -318.498)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(63.363 87.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M232.41,319.619l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-228.127 -319.619)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(67.929 90.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M234.637,320.741l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-230.354 -320.741)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(81.628 97.173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M241.318,324.106l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-237.035 -324.106)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(86.195 99.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M243.545,325.227l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-239.262 -325.227)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    transform: "translate(90.761 101.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M245.772,326.349l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-241.489 -326.349)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(95.327 104.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M248,327.471l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-243.715 -327.471)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(113.593 113.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M256.907,331.957l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-252.623 -331.957)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(122.725 117.872)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M261.361,334.2l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-257.077 -334.2)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(127.291 120.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M263.588,335.322l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-259.304 -335.322)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(136.424 124.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M268.042,337.565l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-263.758 -337.565)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    transform: "translate(45.381 83.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M223.64,317.387l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-219.357 -317.387)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644",
    transform: "translate(49.947 85.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M225.867,318.509l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-221.584 -318.509)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646",
    transform: "translate(54.513 87.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M228.094,319.63l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-223.811 -319.63)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(63.646 92.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M232.548,321.874l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-228.265 -321.874)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(68.212 94.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M234.775,323l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-230.492 -322.995)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(86.478 104.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M243.683,327.482l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-239.4 -327.482)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(95.61 108.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M248.137,329.725l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-243.853 -329.725)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(100.177 110.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M250.364,330.846l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-246.08 -330.846)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(104.743 113.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M252.591,331.968l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-248.307 -331.968)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(109.309 115.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M254.818,333.09l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-250.534 -333.09)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(113.875 117.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M257.045,334.211l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-252.761 -334.211)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(118.442 120.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M259.272,335.333l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-254.988 -335.333)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(127.574 124.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M263.726,337.576l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-259.442 -337.576)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(36.531 83.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M219.324,317.4l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-215.041 -317.398)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(41.097 85.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M221.551,318.52l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-217.268 -318.52)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(45.664 88.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M223.778,319.641l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-219.495 -319.641)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(50.23 90.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M226.005,320.763l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-221.722 -320.763)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(54.796 92.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M228.232,321.884l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-223.949 -321.884)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(59.363 94.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M230.459,323.006l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-226.176 -323.006)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(73.062 101.818)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M237.14,326.371l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-232.857 -326.371)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(82.194 106.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M241.594,328.614l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-237.311 -328.614)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(86.761 108.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M243.821,329.736l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-239.538 -329.736)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(91.327 111.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M246.048,330.857l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-241.765 -330.857)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(95.893 113.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M248.275,331.979l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-243.991 -331.979)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(100.459 115.617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M250.5,333.1l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-246.218 -333.101)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(114.158 122.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M257.183,336.465l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-252.899 -336.465)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(123.291 127.116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M261.637,338.709l4.566,2.3-4.283,2.322-4.566-2.3Z",
    transform: "translate(-257.353 -338.709)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(94.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M268.7,279.082l22.375,11.269L270.089,301.73,247.714,290.46Z",
    transform: "translate(-238.423 -274.228)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M300.336,290.4,277.961,279.13l-4.794-2.416-4.5,2.438-20.989,11.38-4.5,2.438,4.794,2.413,22.375,11.269,4.794,2.415,4.5-2.438,20.989-11.378,4.5-2.438ZM274.85,304.216l-22.377-11.269,20.989-11.378,22.377,11.269Z",
    transform: "translate(-243.183 -276.715)",
    fill: "#4553c7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(194.694 50.597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M317.7,303.758l22.375,11.269-20.988,11.378-22.375-11.269Z",
    transform: "translate(-287.416 -298.905)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M349.329,315.074,326.954,303.8l-4.794-2.413-4.5,2.438-20.989,11.378-4.5,2.438,4.794,2.415,22.375,11.269,4.8,2.413,4.5-2.438,20.989-11.378,4.5-2.438Zm-25.485,13.818-22.375-11.269,20.989-11.378,22.375,11.267Z",
    transform: "translate(-292.176 -301.391)",
    fill: "#4553c7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(0 51.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M222.746,304l22.375,11.269-20.989,11.379-22.375-11.269Z",
    transform: "translate(-192.464 -299.144)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M254.38,315.315,232,304.045l-4.794-2.415-4.5,2.438-20.989,11.378-4.5,2.44,4.8,2.413L224.4,331.569l4.794,2.415,4.5-2.438,20.989-11.38,4.5-2.438Zm-25.487,13.816-22.375-11.269,20.989-11.378,22.375,11.269Z",
    transform: "translate(-197.225 -301.63)",
    fill: "#4553c7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(111.934 9.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M264.665,281.223l13.7,6.9-12.85,6.966-13.7-6.9Z",
    transform: "translate(-251.815 -281.223)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(212.393 59.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M313.658,305.9l13.7,6.9-12.85,6.966-13.7-6.9Z",
    transform: "translate(-300.808 -305.899)",
    fill: "#4553c7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(17.7 60.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M218.707,306.138l13.7,6.9L219.556,320l-13.7-6.9Z",
    transform: "translate(-205.857 -306.138)",
    fill: "#4553c7"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginScreen);
export default __webpack_public_path__ + "static/media/loginScreen.0c80794a586e90d61d3aae93482e5f24.svg";
export { ForwardRef as ReactComponent };